import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function ReferencesPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>References</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              <ul>
                <li>
                  Andrienko, G.; Andrienko, N.; Jankowski, P.; Keim, D.; Kraak,
                  M.J.; MacEachren, A.; Wrobel, S. Geovisual analytics for
                  spatial decision support: Setting the research agenda.{" "}
                  <em>Int. J. Geogr. Inf. Sci.</em> 2007; 21, 839-857. doi:
                  10.1080/13658810701349011.&nbsp;
                </li>
                <li>
                  Beard, R.; Wentz, E.; Scotch, M. A systematic review of
                  spatial decision support systems in public health informatics
                  supporting the identification of high risk areas for zoonotic
                  disease outbreaks. <em>Int. J. Health. Geogr.</em> 2018;17,
                  17-38. doi: 10.1186/s12942-018-0157-5.&nbsp;
                </li>
                <li>
                  Bharath, S.; Bharath, A.H.; Rajan, K.S.; Ramachandra, TV. Cost
                  effective mapping, monitoring and visualisation of spatial
                  patterns of urbanisation using FOSS.&nbsp;In:{" "}
                  <em>
                    Proceeding of FOSS 4G, First National Conference on Open
                    Source Geospatial Resources to Spearhead Development and
                    Growth, India
                  </em>
                  . 2012; 1, 12-20.
                </li>
                <li>
                  Bharath, S.; Rajan, K.S.; Ramchandra, T.V. Visualization of
                  Forest Transition in Uttar Kannada. In:{" "}
                  <em>
                    Proceedings of: Lake 2014, Conference on Conservation and
                    Sustainable Management of Wetland Ecosystem in Western
                    Ghats,
                  </em>{" "}
                  2014; 14, 187-190.
                </li>
                <li>
                  Brooks, T.M.; Mittermeier, R.A.; Mittermeier, C.G.; Da
                  Fonseca, G.A.; Rylands, A.B.; Konstant, W.R.; Flick, P.;
                  Pilgrim, J.; Oldfield, S.; Magin, G.; Hilton‐Taylor, C.
                  Habitat loss and extinction in the hotspots of biodiversity.{" "}
                  <em>Conserv Biol.</em> 2002, 16, 909-923. doi:
                  10.1046/j.1523-1739.2002.00530.x.
                </li>
                <li>
                  Brovelli, M.A.; Magni, D. An archaeological web GIS
                  application based on Mapserver and PostGIS.
                  <em> Int. Arch. Photogramm. Remote Sens. Spat. Inf. Sci</em>.
                  2003, 34, 89-94.
                </li>
                <li>
                  Coetzee, B.W.; Gaston, K.J.; Chown, S.L. Local scale
                  comparisons of biodiversity as a test for global protected
                  area ecological performance: a meta-analysis.{" "}
                  <em>PLoS One.</em> 2014, 9, 2-12, e105824. doi:
                  10.1371/journal.pone.0105824.&nbsp;
                </li>
                <li>
                  Crossland, M.D.; Wynne, B.E.; Perkins, W.C. Spatial decision
                  support systems: An overview of technology and a test of
                  efficacy.&nbsp;<em>Decis. Support Syst</em>.&nbsp;1995, 14,
                  219-235. doi: 10.1016/0167-9236(94)00018-N
                </li>
                <li>
                  Ferretti ,V.; Montibeller, G. Key challenges and meta-choices
                  in designing and applying multi-criteria spatial decision
                  support systems. <em>Decis. Support. Syst.</em> 2016, 84,
                  41-52. doi: 10.1016/j.dss.2016.01.005.
                </li>
                <li>
                  Gebetsroither-Geringer, E.; Stollnberger, R.; Peters-Anders,
                  J. Interactive Spatial Web-Applications as new means of
                  Support for Urban Decision-Making Processes.{" "}
                  <em>Int. Ann. Photogramm. Remote Sens. Spat. Inf. Sci.</em>{" "}
                  2018, 4, 59-66.
                </li>
                <li>
                  Gray, C.L.; Hill, S.L.; Newbold, T.; Hudson, L.N.;
                  B&ouml;rger, L.; Contu, S.; Hoskins, A.J.; Ferrier, S.;
                  Purvis, A.; Scharlemann, J.P. Local biodiversity is higher
                  inside than outside terrestrial protected areas worldwide.{" "}
                  <em>Nat. Commun. </em>2016, 7, 12-20, 12306. doi:
                  10.1038/ncomms12306.
                </li>
                <li>
                  Haddad, N.M.; Brudvig, L.A.; Clobert, J.; Davies, K.F.;
                  Gonzalez, A.; Holt, R.D.; Lovejoy, T.E.; Sexton, J.O.; Austin,
                  M.P.; Collins, C.D.; Cook, W.M. Habitat fragmentation and its
                  lasting impact on Earth&rsquo;s ecosystems. <em>Sci. Adv.</em>{" "}
                  2015, 1, 23-30, e1500052. doi: 10.1126/sciadv.1500052.&nbsp;
                </li>
                <li>
                  Haase, D.; Schwarz, N. Simulation models on human-nature
                  interactions in urban landscapes: a review including spatial
                  economics, system dynamics, cellular automata and agent-based
                  approaches.&nbsp;<em>Living Rev. Landsc. Res.</em>&nbsp;2009,
                  3,1-45. doi: 10.12942/lrlr-2009-2.&nbsp;
                </li>
                <li>
                  Jenkins, C.N.; Joppa, L. Expansion of the global terrestrial
                  protected area system. <em>Biol. Cons.</em> 2009, 142,
                  2166-2174. doi: 10.1016/j.biocon.2009.04.016.&nbsp;
                </li>
                <li>
                  Joppa , L.N.; Pfaff, A. Global protected area
                  impacts.&nbsp;In:{" "}
                  <em>
                    Proceedings of the Royal Society of London B: Biological
                    Sciences.
                  </em>{" "}
                  2011, 278,1633-1638. doi: 10.1098/rspb.2010.1713.&nbsp;
                </li>
                <li>
                  Karnatak, H.; Roy, A. Himalayan spatial biodiversity
                  information system. In:{" "}
                  <em>Remote Sensing of Northwest Himalayan Ecosystems.</em>{" "}
                  Springer, Singapore. 2019, pp.237-249.
                </li>
                <li>
                  Kiesecker, J.M.; McKenney, B.; Kareiva, P. Offsets: factor
                  failure into protected areas. <em>Nature</em>. 2015, 525
                  (7567), 33-37. doi:10.1038/525033c.
                </li>
                <li>
                  Laurance, W.F.; Useche, D.C.; Rendeiro, J.; Kalka, M.;
                  Bradshaw, C.J.; Sloan, S.P.; Laurance, S.G.; Campbell, M.;
                  Abernethy, K.; Alvarez, P.; Arroyo-Rodriguez, V. Averting
                  biodiversity collapse in tropical forest protected areas.{" "}
                  <em>Nature</em>. 2012, 489(7415):290-294.
                </li>
                <li>
                  Matthies, M.; Giupponi, C.; Ostendorf, B. Environmental
                  decision support systems: Current issues, methods and tools.{" "}
                  <em>Environ Model Softw.</em> 2007, 22,123-127. doi:
                  10.1016/j.envsoft.2005.09.005.&nbsp;
                </li>
                <li>
                  Nelson, A.; Chomitz, K.M. Effectiveness of strict vs. multiple
                  use protected areas in reducing tropical forest fires: a
                  global analysis using matching methods. <em>PLoS One.</em>{" "}
                  2011, 6 (8): 1-14, e22722. doi: 10.1371/journal.pone.0022722.
                </li>
                <li>
                  Nolte, C.; Agrawal, A.; Silvius, K.M.; Soares-Filho, B.S.
                  Governance regime and location influence avoided deforestation
                  success of protected areas in the Brazilian Amazon.{" "}
                  <em>Proc. Natl. Acad. Sci.U.S.A.</em> 2013, 110, 4956-4961.
                  doi: 10.1073/pnas.1214786110.
                </li>
                <li>
                  Ramachandra, T.V.; Bharath, S. Global warming mitigation
                  through carbon sequestrations in the central Western Ghats.{" "}
                  <em>Remote Sens. Earth Syst. Sci.</em> 2019, 1-25. doi:
                  10.1007/s41976-019-0010-z.&nbsp;
                </li>
                <li>
                  Ramachandra, T.V.; Bharath, S.; Chandran, M.D.S. Geospatial
                  analysis of forest fragmentation in Uttara Kannada District,
                  India.&nbsp;<em>For. Ecosyst.</em> 2016, 3(10):1-15. doi:
                  10.1186/s40663-016-0069-4.
                </li>
                <li>
                  Ramachandra, T.V.; Bharath, S.; Rajan, K.S.; Chandran, M.D.S.
                  Modelling the forest transition in Central Western Ghats,
                  India.&nbsp;<em>Spat. Inf. Res.</em> 2017, 25, 117-130. doi:
                  10.1007/s41324-017-0084-8.
                </li>
                <li>
                  Ramachandra, T.V.; Bharath, S. Geoinformatics based valuation
                  of forest landscape dynamics in central Western Ghats, India.{" "}
                  <em>J. Remote Sens. GIS.</em> 2018a, 7 (1): 227-235. doi:
                  10.4172/2469-4134.1000227.
                </li>
                <li>
                  Ramachandra, T.V.; Bharath, S.; Gupta, N. Modelling landscape
                  dynamics with LST in protected areas of Western Ghats,
                  Karnataka.&nbsp;<em>J Environ Manage.&nbsp;</em>2018b, 206,
                  1253-1262. doi: 10.1016/j.jenvman.2017.08.001.
                </li>
                <li>
                  Ramachandra, T.V.; Kumar, U. Spatial decision support system
                  for land use planning. <em>ICFAI Univ. J. Environ. Sci.</em>{" "}
                  2008, 2, 7-19.
                </li>
                <li>
                  Ruda, A. Spatial decision support using data
                  geo-visualization: the example of the conflict between
                  landscape protection and tourism development.{" "}
                  <em>J. Maps.</em> 2016, 12,1262-1267. doi:
                  10.1080/17445647.2016.1152915.&nbsp;
                </li>
                <li>
                  Steiniger, S.; Hay, G.J. Free and open source geographic
                  information tools for landscape ecology. <em>Ecol. Info.</em>{" "}
                  2009, 4,183-195. doi: 10.1016/j.ecoinf.2009.07.004.&nbsp;
                </li>
                <li>
                  Su, S.; Yang, C.; Hu, Y.; Luo, F.; Wang, Y. Progressive
                  landscape fragmentation in relation to cash crop
                  cultivation.&nbsp;<em>Appl Geogr.</em> 2014, 53, 20-31. doi:
                  10.1016/j.apgeog.2014.06.002.
                </li>
                <li>
                  Sugumaran, R.; Degroote, J.{" "}
                  <em>
                    Spatial decision support systems: Principles and practices.
                  </em>{" "}
                  CRC Press. 2010. Pp508. doi: 10.1201/b10322.
                </li>
              </ul>
            </p>
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default ReferencesPage;
